export default __webpack_public_path__ + "static/media/free_registration.2b2d4433.jpg";